import { render, staticRenderFns } from "./PackagePeriodDetail.vue?vue&type=template&id=5c4042fe&scoped=true&"
import script from "./PackagePeriodDetail.vue?vue&type=script&lang=js&"
export * from "./PackagePeriodDetail.vue?vue&type=script&lang=js&"
import style0 from "./PackagePeriodDetail.vue?vue&type=style&index=0&id=5c4042fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4042fe",
  null
  
)

export default component.exports